/* RESPONSIBLE TEAM: team-standalone */

import { OnboardingGuideStepData } from '../definitions';
import type SalesforcePlatform from '../../salesforce';

export default class SalesforceOnboardingGuideStep extends OnboardingGuideStepData {
  protected platform: SalesforcePlatform;

  constructor(platform: SalesforcePlatform) {
    super(platform);
    this.platform = platform;
  }

  get app() {
    return this.platform.finStandaloneService.app;
  }

  override titleKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.salesforce.title`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.title`;
  }

  override descriptionKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.salesforce.description`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.description`;
  }

  override ctaKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.salesforce.cta`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.cta`;
  }

  override secondaryCTAKey(stepIdentifier: string): string {
    return `onboarding.getting-started.steps.${stepIdentifier}.secondary-cta`;
  }

  override get platformName() {
    return this.platform.intl.t('onboarding.getting-started.platforms.salesforce.name');
  }

  private platformIsDependent(stepIdentifier: string): boolean {
    return (
      stepIdentifier === 'fin_sa_onboarding_add_integration' ||
      stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live'
    );
  }

  override moreInfoLinkLabel(_stepIdentifier: string): string | null {
    return null;
  }

  override moreInfoArticleId(_stepIdentifier: string): number | undefined {
    return undefined;
  }

  override shouldShowConnectDrawer(stepIdentifier: string): boolean {
    if (this.app.canUseReactSalesforceDeployPages) {
      return false;
    } else {
      return (
        stepIdentifier === 'fin_sa_onboarding_add_integration' ||
        stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live'
      );
    }
  }
}
